import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b23e805a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b23e805a')) {
      api.createRecord('b23e805a', component.options)
    } else {
      api.reload('b23e805a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b23e805a&", function () {
      api.rerender('b23e805a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZETQSZRphW4Y/JS/comp/FavElement.vue"
export default component.exports